import { createContextualCan } from '@casl/react';

import { AbilityContext } from '~/core/contexts/AbilityContext';
import { AppAbility } from '~/shared/types/Permission';

export const Can = createContextualCan<AppAbility>(AbilityContext.Consumer);
